import React, { useEffect, useState } from 'react';
import '../Assets/Css/AddTaskStatusModal.scss';
import { Modal, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import closeIcon from '../Assets/Images/Pop-Up/Close_button.svg'

function AddProjectMilestonesModal({
    isOpen,
    onClose,
    addProjectMilestones,
    loading,
    deleteProjectMilestones,
    deleteLoading,
    updateProjectMilestones,
    projectMilestonesList,
    setProjectMilestonesList,
    addProjectMilestonePayload
}) {
    const [labelName, setLabelName] = useState('');
    const [updateId, setUpdateId] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [isAdd, setIsAdd] = useState(false);

    const handleDelete = async (id) => {
        setIsAdd(false);
        try {
            await deleteProjectMilestones(id);
            setProjectMilestonesList(prev => prev.filter(item => item.id !== id));
        } catch (error) {
            console.error("Error deleting milestone:", error);
            toast.error("Failed to delete milestone");
        }
    };

    const handleUpdate = (id) => {
        setIsAdd(false);
        try {
            const filtered = projectMilestonesList.find((item) => item.id === id);
            if (filtered) {
                setLabelName(filtered.name);
                setUpdateId(id);
                setIsEdit(true);
            }
        } catch (error) {
            console.error("Error setting up update:", error);
            toast.error("Failed to set up update");
        }
    };

    const handleAddUpdateProjectMilestones = async (e) => {
        e.preventDefault();
        setIsAdd(false);
        try {
            if (!labelName.trim()) {
                toast.error("Please fill the name field");
                return;
            }
            const body = { name: labelName.trim() };

            if (updateId) {
                await updateProjectMilestones(updateId, body);
                setProjectMilestonesList(prev =>
                    prev.map(item =>
                        item.id === updateId ? { ...item, name: labelName.trim() } : item
                    )
                );
                setUpdateId(null);
                setIsEdit(false);
            } else {
                await addProjectMilestones(body);
            }

            setLabelName('');
        } catch (error) {
            console.error("Error in add/edit milestone:", error);
            toast.error("Failed to save milestone");
        }
    };

    const handleCancelEdit = () => {
        setIsEdit(false);
        setUpdateId(null);
        setLabelName('');
        setIsAdd(false);
    };

    useEffect(() => {
        if (addProjectMilestonePayload) {
            setProjectMilestonesList(prev => [...prev, addProjectMilestonePayload]);
        }
    }, [addProjectMilestonePayload, setProjectMilestonesList]);

    // Removed the unused handleTextChange function that referenced undefined setColorValue

    return (
        <Modal
            show={isOpen}
            onHide={onClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="custom-modal"
        >
            <div className="modal-content">
                <div className="modal-header">
                    <h5>Milestones</h5>
                    <button className="close-btn" onClick={onClose}>
                        {<img src={closeIcon} alt="Close" />}
                    </button>
                </div>
                <div className="modal-body">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th className='text-center'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {projectMilestonesList?.map((item, index) => (
                                <tr key={item.id} className='align-middle'>
                                    <td>{index + 1}</td>
                                    <td className='w-100'>
                                        {isEdit && updateId === item.id ? (
                                            <form onSubmit={handleAddUpdateProjectMilestones}>
                                                <input
                                                    type="text"
                                                    value={labelName}
                                                    onChange={(e) => setLabelName(e.target.value)}
                                                    placeholder='Enter Project Milestone Name'
                                                    autoFocus
                                                    className="popup-input"
                                                />
                                            </form>
                                        ) : (
                                            item.name
                                        )}
                                    </td>
                                    <td className="action-buttons d-flex justify-content-center">
                                        {isEdit && updateId === item.id ? (
                                            <>
                                                <button
                                                    onClick={handleAddUpdateProjectMilestones}
                                                    className='update-btn mx-1'
                                                    disabled={loading}
                                                >
                                                    {loading ? <Spinner size="sm" /> : "Save"}
                                                </button>
                                                <button
                                                    onClick={handleCancelEdit}
                                                    className='cancel-btn mx-1'
                                                >
                                                    Cancel
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                <button
                                                    onClick={() => handleUpdate(item.id)}
                                                    className='update-btn mx-1'
                                                    disabled={loading || isEdit || isAdd}
                                                >
                                                    Update
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(item.id)}
                                                    className='delete-btn mx-1'
                                                    disabled={deleteLoading || isEdit || isAdd}
                                                >
                                                    {deleteLoading ? <Spinner size="sm" /> : "Delete"}
                                                </button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            {isAdd && (
                                <tr key="new-record" className='align-middle'>
                                    <td>{projectMilestonesList?.length + 1 || 1}</td>
                                    <td className='w-100'>
                                        <form onSubmit={handleAddUpdateProjectMilestones}>
                                            <input
                                                type="text"
                                                value={labelName}
                                                onChange={(e) => setLabelName(e.target.value)}
                                                placeholder='Enter Project Milestone Name'
                                                autoFocus
                                                className="popup-input"
                                            />
                                        </form>
                                    </td>
                                    <td className="action-buttons d-flex justify-content-center">
                                        <button
                                            onClick={handleAddUpdateProjectMilestones}
                                            className='update-btn mx-1'
                                            disabled={loading}
                                        >
                                            {loading ? <Spinner size="sm" /> : "Save"}
                                        </button>
                                        <button
                                            onClick={handleCancelEdit}
                                            className='cancel-btn mx-1'
                                        >
                                            Cancel
                                        </button>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="modal-footer">
                    <button
                        className="save-btn"
                        onClick={() => setIsAdd(true)}
                        disabled={loading || isEdit || isAdd}
                    >
                        Add Milestone
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default AddProjectMilestonesModal;